import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { I18nService } from '../../../core/services/i18n.service';

export interface LanguageOption {
  code: string;
  label: string;
}

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageSelectorComponent {
  @Input() isVisible = false;
  @Output() close = new EventEmitter<void>();
  @Output() languageChanged = new EventEmitter<string>();

  private readonly i18nService = inject(I18nService);

  get currentLanguage(): string {
    return this.i18nService.locale();
  }

  readonly languages: LanguageOption[] = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' }
  ];

  selectLanguage(langCode: string): void {
    if (this.currentLanguage === langCode) {
      this.close.emit();
      return;
    }
    this.i18nService.setLocale(langCode as 'es' | 'en');
    this.languageChanged.emit(langCode);
    this.close.emit();
  }

  onClose(): void {
    this.close.emit();
  }
}
